define('modules/editor/models/facebookapi',['require','exports','module','backbone'],function(require, exports, module){
	"use strict";
	var Backbone = require("backbone");
	var FacebookAPI = Backbone.Model.extend({
    defaults: {
      appId: "",
      version: "v2.0",
      xfbml: true
    },
    initialize: function() {
      this.on("change:appId", this.init);
    },
    init: function() {
      return window.FB && window.FB.init(this.attributes);
    },
    parse: function() {
      return window.FB && window.FB.XFBML.parse();
    }
  });

  module.exports = FacebookAPI;
});

